class CollectionFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.filterData = [];
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.productGridId = 'CollectionProductGrid';
    this.filterFormsId = 'CollectionFiltersForm';
    this.sections = this.getSections();
    this.filterWrapper = document.querySelector('collection-filtering-form');
    this.filterDrawer = this.filterWrapper.querySelector('#CollectionFiltersForm');

    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    document.querySelector('[data-drawer-open-btn]').addEventListener('click', this.handleDrawerOpen.bind(this));
    this.addDrawerListeners.bind(this);
    window.addEventListener('resize', this.addDrawerListeners.bind(this));
    window.addEventListener('popstate', this.onHistoryChange.bind(this));

    this.bindActiveFacetButtonEvents();

  }

  isHidden(el) {
    return (el.offsetParent === null)
  }

  addDrawerListeners() {
    const drawerOpenBtn = document.querySelector('[data-drawer-open-btn]');

    this.filterDrawer.removeAttribute('role')
    this.filterDrawer.removeAttribute('aria-modal');

    if (window.innerWidth < 991) {
      this.filterDrawer.setAttribute('role', 'dialog')
      this.filterDrawer.setAttribute('aria-modal', 'true');
    }

    if (this.isHidden(drawerOpenBtn)) return;

    drawerOpenBtn.addEventListener('click', this.handleDrawerOpen);
  }

  handleDrawerOpen(e) {
    e.target.setAttribute('tabIndex', '-1');
    const drawerCloseBtn = this.querySelector('[data-drawer-close-btn]')

    this.filterWrapper.classList.add('is-open');
    document.body.classList.add('js-drawer-open-left', 'js-drawer-open');
    this.trapFocus('main-collection-filters', true);
    drawerCloseBtn.addEventListener('click', this.handleDrawerClose.bind(this));

    document.addEventListener('click', (e) => this.handleOffDrawerClick(e), true);
  }

  handleOffDrawerClick(e) {
    // @todo: figure out why this method keeps getting called
    const isDrawerClick = this.filterDrawer.contains(e.target);

    if (!isDrawerClick) this.handleDrawerClose();
  }

  handleDrawerClose() {
    const filterBtn = document.querySelector('[data-drawer-open-btn]');

    document.body.classList.remove('js-drawer-open-left', 'js-drawer-open');
    this.filterWrapper.classList.remove('is-open');

    filterBtn.setAttribute('tabIndex', '0');
    filterBtn.focus();
    document.removeEventListener('click', this.handleOffDrawerClick, true);
  }

  trapFocus(slideout_id, is_initial_open) {
    const idString = `#${slideout_id}`;
    const menu = document.getElementById(slideout_id);
    const togglers = document.querySelectorAll('.facets__disclosure, .collection-filters__sort');
    const inputs = document.querySelectorAll(`${idString} input:not([type=hidden]), ${idString} button:not([tabindex="-1"]), ${idString} a:not([tabindex="-1"]), ${idString} textarea`);
    // The first input will always stay the same so we'll declare it here
    const firstInput = inputs[0];
    let lastInput;


    menu.addEventListener('keydown', function (e) {
      const getLastToggler = (togglers[togglers.length - 1]);
      const lastGroupCollapsed = !getLastToggler.hasAttribute('open');

      // If the last tag list is collapsed, the toggle button becomes the 'last input'
      // else the last input is equal to the last input in the array
      lastInput = lastGroupCollapsed ? getLastToggler : (inputs[inputs.length - 1]);

      // Redirect last tab to first input
      if (e.code === 'Tab' && !e.shiftKey && document.activeElement == lastInput) {
        e.preventDefault();
        firstInput.focus();
      }

      // Redirect first shift+tab to last input
      if (e.code === 'Tab' && e.shiftKey && document.activeElement == firstInput) {
        e.preventDefault();
        lastInput.focus();
      }
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    this.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    this.toggleActiveFacets();
    this.renderPage(new URL(event.target.href).searchParams.toString());
  }

  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, null, false);
  }

  toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  renderPage(searchParams, event, updateURLHash = true) {
    document.querySelector(`#${this.productGridId}>div`).classList.add('loading');

    this.sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      this.filterData.some(filterDataUrl) ?
        this.renderSectionFromCache(filterDataUrl, section, event) :
        this.renderSectionFromFetch(url, section, event);
    });

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderSectionFromFetch(url, section, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        this.filterData = [...this.filterData, { html, url }];

        switch (section.id) {
          case this.productGridId:
            this.renderProductGrid(html);
            break;
          case this.filterFormsId:
            this.renderFilters(html, event);
            break;
          default:
            return;
        }
      });
  }

  renderSectionFromCache(filterDataUrl, section, event) {
    const html = this.filterData.find(filterDataUrl).html;
    this.renderFilters(html, event);
    this.renderProductGrid(html);
  }

  renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById(this.productGridId).innerHTML;

    document.getElementById(this.productGridId).innerHTML = innerHTML;

    const event = new CustomEvent('paginate');
    document.dispatchEvent(event);
  }

  renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll(`#${this.filterFormsId} .js-filter`);
    const matchesIndex = (element) => element.dataset.index === event?.target.closest('.js-filter')?.dataset.index
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    this.renderActiveFacets(parsedHTML);

    if (countsToRender) this.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    this.bindActiveFacetButtonEvents();
    this.toggleActiveFacets(false);
  }

  renderMobileElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count'];

    mobileElementSelectors.forEach((selector) => {
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('CollectionFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  renderCounts(source, target) {
    const countElementSelectors = ['.count-bubble', '.facets__selected'];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);

      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
      }
    });
  }

  bindActiveFacetButtonEvents() {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick, { once: true });
    });
  }

  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  getSections() {
    return [
      {
        id: this.productGridId,
        section: document.getElementById(this.productGridId).dataset.sectionId
      },
      {
        id: this.filterFormsId,
        section: document.getElementById('main-collection-filters').dataset.id
      }
    ]
  }
}

customElements.define('collection-filtering-form', CollectionFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
   
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input[type="number"]');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', '0');
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range-selector', PriceRange);

/*
document.addEventListener('input', function (e) {
  if (!e.target.classList.contains('price-range')) return;

  const wrapper = e.target.closest('.price-range-wrapper');

  const minSlider = wrapper.querySelector('.price-range--min');
  const maxSlider = wrapper.querySelector('.price-range--max');

  const minValue = Math.min(+minSlider.value, +maxSlider.value - 1);
  const maxValue = Math.max(+maxSlider.value, +minSlider.value + 1);

  minSlider.value = minValue;
  maxSlider.value = maxValue;

  wrapper.querySelector('.price-min').textContent =
    wrapper.dataset.currency + minValue;

  wrapper.querySelector('.price-max').textContent =
    wrapper.dataset.currency + maxValue;

  wrapper.querySelector('.price-filter-min').value = minValue;
  wrapper.querySelector('.price-filter-max').value = maxValue;
});

*/
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.price-range-wrapper').forEach(wrapper => {
    updatePriceRange(wrapper);
  });
});

document.addEventListener('input', function (e) {
  if (!e.target.classList.contains('price-range')) return;

  const wrapper = e.target.closest('.price-range-wrapper');
  const minInput = wrapper.querySelector('.price-range--min');
  const maxInput = wrapper.querySelector('.price-range--max');
  const fill = wrapper.querySelector('.price-range-fill');

  let min = parseInt(minInput.value);
  let max = parseInt(maxInput.value);
  const rangeMax = parseInt(wrapper.dataset.max);

  if (min > max - 1) min = max - 1;
  if (max < min + 1) max = min + 1;

  minInput.value = min;
  maxInput.value = max;

  const minPercent = (min / rangeMax) * 100;
  const maxPercent = (max / rangeMax) * 100;
  updatePriceRange(wrapper);

  fill.style.left = minPercent + '%';
  fill.style.width = (maxPercent - minPercent) + '%';

  wrapper.querySelector('.price-min').textContent =
    wrapper.dataset.currency + min;

  wrapper.querySelector('.price-max').textContent =
    wrapper.dataset.currency + max;

  wrapper.querySelector('.price-filter-min').value = min;
  wrapper.querySelector('.price-filter-max').value = max;
});

function updatePriceRange(wrapper) {
  const minInput = wrapper.querySelector('.price-range--min');
  const maxInput = wrapper.querySelector('.price-range--max');
  const fill = wrapper.querySelector('.price-range-fill');

  let min = parseInt(minInput.value, 10);
  let max = parseInt(maxInput.value, 10);
  const rangeMax = parseInt(wrapper.dataset.max, 10);

  if (min > max - 1) min = max - 1;
  if (max < min + 1) max = min + 1;

  minInput.value = min;
  maxInput.value = max;

  const minPercent = (min / rangeMax) * 100;
  const maxPercent = (max / rangeMax) * 100;

  fill.style.left = minPercent + '%';
  fill.style.width = (maxPercent - minPercent) + '%';

  wrapper.querySelector('.price-min').textContent =
    wrapper.dataset.currency + min;

  wrapper.querySelector('.price-max').textContent =
    wrapper.dataset.currency + max;

  wrapper.querySelector('.price-filter-min').value = min;
  wrapper.querySelector('.price-filter-max').value = max;
}
